import type { ReactNode } from "react";
import type { GridProps } from "@mui/material";
import { Typography, Stack, Checkbox, Grid } from "@mui/material";
import { TerritoireBox } from "components/Business";
import type { Territoire } from "models";

interface RecapitulatifDeselectionnableTerritoireProps extends GridProps {
  territoires?: Array<Partial<Territoire>>;
  onTerritoireChange: (territoire: Array<Territoire>) => void;
}

export function RecapitulatifDeselectionnableTerritoire({
  territoires,
  onTerritoireChange: onChange,
  ...gridProps
}: Readonly<RecapitulatifDeselectionnableTerritoireProps>): ReactNode {
  if (territoires == null || territoires.length === 0) return null;

  return (
    <Grid container size={12} spacing={2} {...gridProps}>
      <Typography component={Grid} size={12}>
        Récapitulatif des territoires sélectionnés :
        <br />
        <Typography component="span" variant="caption" color="text.secondary">
          Cliquez sur un territoire pour le retirer de la sélection
        </Typography>
      </Typography>

      <Stack spacing={0}>
        {territoires?.map((t) => (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            key={t.id}
            onClick={() => {
              onChange(((territoires ?? []) as Array<Territoire>).filter((ter) => ter.id !== t.id));
            }}
            sx={{ cursor: "pointer" }}>
            <Checkbox checked size="small" sx={{ p: 0.5 }} />
            <TerritoireBox territoire={t as Territoire} />
          </Stack>
        ))}
      </Stack>
    </Grid>
  );
}
